import React, { useContext, useEffect, useMemo } from 'react';
import {
  arrayOf, bool, func, number, shape, string
} from 'prop-types';
import {
  Button,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  ProgressBar,
  Typography
} from '@one-thd/sui-atomic-components';
import { ProductListContext } from '../ProductListContext';
import { PRODUCTS_LOADING_MESSAGE } from '../action-bar/constants';

export const LoadingDrawer = ({
  arrayOfSelectedItems,
  onClose,
  onLoadingSuccess,
  open,
  title
}) => {

  const {
    page,
    productsDisplayed,
    setPage
  } = useContext(ProductListContext);

  const loadingProgress = useMemo(() => {
    const totalProducts = arrayOfSelectedItems?.length || 0;
    if (totalProducts === 0) return 0;

    const matchCount = arrayOfSelectedItems.filter((product) => {
      const productItemId = product?.itemId;
      const productId = product?.id;

      return productsDisplayed.some((obj) => (productItemId && obj?.itemId === productItemId)
        || (productId && obj?.key === productId)
      );
    }).length;

    return Math.round((matchCount / totalProducts) * 100);
  }, [productsDisplayed, arrayOfSelectedItems]);

  useEffect(() => {
    if (open && loadingProgress === 100) {
      onLoadingSuccess();
    } else if (open && loadingProgress !== 100) {
      setPage(page + 1);
    }
  }, [loadingProgress, open]);

  const numberOfItems = arrayOfSelectedItems?.length ?? 0;

  return (
    <Drawer open={open} onClose={onClose} size="sm">
      <DrawerHeader
        title={title}
        onClose={onClose}
      />
      <DrawerBody>
        <div className="sui-min-h-screen">
          <Typography variant="body-lg" weight="bold">Hang Tight!</Typography>
          <Typography variant="body-base">
            {PRODUCTS_LOADING_MESSAGE}
          </Typography>
          <div className="sui-pt-8">
            <ProgressBar
              status={loadingProgress === 100 ? 'success' : undefined}
              value={loadingProgress}
              startLabel={`${numberOfItems} items`}
              endLabel={`${loadingProgress}%`}
            />
          </div>
        </div>
      </DrawerBody>
      <DrawerFooter>
        <Button
          fullWidth
          onClick={onClose}
          variant="secondary"
        >
          Cancel
        </Button>
      </DrawerFooter>
    </Drawer>
  );
};

LoadingDrawer.propTypes = {
  arrayOfSelectedItems: arrayOf(shape(
    {
      itemId: string.isRequired,
      id: string.isRequired,
      quantity: number.isRequired,
    }
  )).isRequired,
  onLoadingSuccess: func,
  onClose: func.isRequired,
  open: bool.isRequired,
  title: string,
};

LoadingDrawer.defaultProps = {
  onLoadingSuccess: () => {},
  title: 'Loading your items',
};